var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('WidgetLoad')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }